import CustomerInformationComponent from "@/app/components/routes/auth_routes/CustomerProfile/CustomerDetails/CustomerInformation";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useVMSParams } from "@/app/hooks/useVMSParams";
import { ROUTES } from "@/app/routes";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { RESET_SLOTS_SLICE } from "@/app_redux/reducers/slices/auth/slots_slice";
import React, { useEffect } from "react";
import { useParams } from "react-router";
import { ICustomerDetailsPageProps } from "./interface";


export type CustomerProfileBookmarkType = {
  customer_id: string;
  pet_id: string;
  pet: string;
  customer: string;
  href: string;
};

const CustomerDetailsPage: React.FC<ICustomerDetailsPageProps> = (_props) => {
  const { routeState } = useRouteInfo(ROUTES.ROOT.children.CUSTOMER_PROFILE.id);
  const { customerId } = routeState.state as ICustomerProfileState;
  const params = useParams();
  const dispatch = useAppDispatch();


  useVMSParams();

  useEffect(() => {
    dispatch(RESET_SLOTS_SLICE());
  }, []);

  /* The tabs below read the customer out of the store, not out of the URL, and
     they fetch on mount - so rendering them while the store still holds the
     previous patient is what made the EMR tab open on someone else's records.
     Hold the page back until useVMSParams has swapped the store over.
     Only the customer is compared: the pet is switched through the dropdown
     without rewriting the :pet_id segment, so it would never match. */
  const isRequestedCustomerLoaded =
    Boolean(customerId) && (!params.user_id || params.user_id === customerId);

  return isRequestedCustomerLoaded && (
    <div>
      <CustomerInformationComponent />
    </div>
  )
};

export default CustomerDetailsPage;
